import React, { FC } from 'react';
// import styles from './LandscapeProjectsAddProjectsTemplate.module.css';
import { Container } from 'react-bootstrap';
import BaseTemplate from '../BaseTemplate';
import LandscapeEditProjectsAddProjectTemplate from '../../../templates/LandscapeEditProjectsAddProjectTemplate';
import {
  LandscapeProjectsAddBasicInformationOrganism,
  TranslationOrganism,
} from '../../organisms';
import LandscapeEditProjectsAddProjectBasicInformationTemplate from '../../../templates/LandscapeEditProjectsAddProjectBasicInformationTemplate';
import { ProjectResponseDto } from '../../../store/landscapeAPI/project/dto/response/project-response.dto';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

export interface LandscapeProjectsAddProjectsTemplateProps {
  project: ProjectResponseDto;
  handleOnChange: (project: ProjectResponseDto) => void;
  handleSubmit: () => void;
  openForSupportSelected: boolean;
  setOpenForSupportSelected: React.Dispatch<React.SetStateAction<boolean>>;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const LandscapeProjectsAddProjectsTemplate: FC<
  LandscapeProjectsAddProjectsTemplateProps
> = ({
  project,
  handleOnChange,
  handleSubmit,
  openForSupportSelected,
  setOpenForSupportSelected,
  handleImageOnChange,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeEditProjectsAddProjectTemplate>
          <LandscapeEditProjectsAddProjectBasicInformationTemplate>
            <TranslationOrganism
              setLanguage={setLanguage}
              selectedLanguage={selectedLanguage}
              fromLanguage={fromLanguage}
              setFromLanguage={setFromLanguage}
              toLanguage={toLanguage}
              setToLanguage={setToLanguage}
              generateTranslation={generateTranslation}
              generateAllTranslations={generateAllTranslations}
            />
            <LandscapeProjectsAddBasicInformationOrganism
              project={project}
              handleOnChange={handleOnChange}
              handleSubmit={handleSubmit}
              openForSupportSelected={openForSupportSelected}
              setOpenForSupportSelected={setOpenForSupportSelected}
              handleImageOnChange={handleImageOnChange}
            />
          </LandscapeEditProjectsAddProjectBasicInformationTemplate>
        </LandscapeEditProjectsAddProjectTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeProjectsAddProjectsTemplate;
